import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {finishTutorial} from "../utils/http";
import {AxiosError} from "axios";

// const letters = ['A','2','F','Z','8'];
const letters = ['A','2','F'];

export interface SwipeProps {
    status: boolean;
    swipes: {
        id: number;
        day: number;
        season: number;
        character: string;
        character_index: number;
        can_swipe: boolean;
        time_to_next_hint: string;
        characters: string[];
    }
    codes: [
        {
            id: number;
            day: number;
            season: number;
            completed_season: number;
            completed_day: number;
            claimed:boolean;
            reward: number;
            swiped_characters: string;
            completed_at: string | null;
            swipes: {
                day: number;
                season: number;
                character: string;
                swiped_at: string;
                character_index: number;
            }[];
            }
    ],
    completeCodes: [
        {
            id: number;
            day: number;
            season: number;
            completed_season: number;
            completed_day: number;
            claimed:boolean;
            reward: number;
            swiped_characters: string;
            completed_at: string | null;
            swipes: {
                id: number;
                day: number;
                season: number;
                character: string;
                swiped_at: string;
                can_swipe: boolean;
                time_to_next_hint: string;
                character_index: number;
                characters: string[];
            }[];
        }
    ]
}

const initialState: SwipeProps = {
    status: true,
    swipes: {
        id: 1,
        day: 1,
        season: 1,
        character: letters[0],
        character_index: 0,
        can_swipe: true,
        time_to_next_hint: new Date().toISOString(),
        characters: letters,
    },
    codes: [
        {
            id: 1,
            day: 1,
            season: 1,
            completed_season: 1,
            completed_day: 1,
            claimed: false,
            reward: 1500,
            swiped_characters: "___",
            completed_at: null,
            swipes: []
        }
    ],
    completeCodes: [
        {
            id: 1,
            day: 1,
            season: 1,
            completed_season: 1,
            completed_day: 1,
            claimed: true,
            reward: 1500,
            swiped_characters: letters.join(''),
            completed_at: new Date('2024-08-01').toISOString(),
            swipes: [
            ]
        }
    ]
}

export const sendFinishTutorial = createAsyncThunk('tutorial/sendFinishTutorial', async (_, {rejectWithValue}) => {
    try {
        const response = await finishTutorial();
        return response.data;
    } catch (_err) {
        const error = _err as AxiosError;
        return rejectWithValue({ data: error.message  });
    }
})

export const tutorialSlice = createSlice({
    name: 'tutorial',
    initialState,
    reducers: {
        setCanSwipe: (state, {payload}) => {
            state.swipes.can_swipe = payload
            const d = new Date();
            const date_future = new Date(d.getTime() + 4000);
            state.swipes.time_to_next_hint = date_future.toISOString();
        },
        fetchSwipeState: (state) => {
            state.swipes.can_swipe = true;
        },
        sendSwipeState: (state,action) => {

            state.swipes.character_index++;
            state.swipes.character = letters[state.swipes.character_index]
            state.swipes.can_swipe = false;
            const d = new Date();
            const date_future = new Date(d.getTime() + 4000);
            state.swipes.time_to_next_hint = date_future.toISOString();
            state.codes.map(code => {
                let str = code.swiped_characters.split('');
                str[action.payload.swipe.character_index] = action.payload.swipe.character;
                code.swiped_characters = str.join('');
                code.swipes.push(action.payload.swipe);
                return code;
            })
        },
        sendCode: (state, action) => {
            if(action.payload.guess !== letters.join('').toUpperCase()) {
                state.status = false;
            } else {
                state.codes.map(code => {
                    code.completed_at = new Date().toISOString();
                    return code;
                })
            }
        },
        setClaimed: (state) => {
            state.codes.map(code => {
                code.claimed = true;
                return code;
            })
        }
    },

})

export const { setCanSwipe, fetchSwipeState, sendSwipeState, sendCode, setClaimed } = tutorialSlice.actions
export default tutorialSlice.reducer
